import React from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';
import I18n from 'i18n-react';
import Analytics from '../../components/modules/tudo-azul-analytics';
import OverviewBreadcrumb from '../../components/overviewSearchBar/overviewBreadcrumb/OverviewBreadcrumb';
import FlightInfoResume from '../../components/bookingResume/flightInfoResume/FlightInfoResume';
import DynamicPanel from '../../components/bookingResume/dynamicPanel/DynamicPanel';
import PaymentData from '../../components/bookingResume/paymentData/PaymentData';
import FlightResume from '../../components/bookingResume/flightResume/FlightResume';
import TravelTips from '../../components/bookingResume/travelTips/TravelTips';
import LoginCookie from '../../components/loginCookie/LoginCookie';
import EventEmitter from '../../components/modules/event-emitter/EventEmitter';
import Listener from '../../const/Listener';
import FeatureService from '../../services/feature/FeatureService';
import { isFromCallcenter } from '../../services/queryService/QueryService';
import Features from '../../const/Features';
import './ResumePage.css';
import LocalStorage from '../../const/LocalStorage';

const POINTS = 'POINTS';
const TAX = 'BRL';
const MONEY = 'MONEY';

class ResumePage extends React.Component {
  constructor() {
    super();

    this.state = {
      isRedirect: false,
      isCallcenterEnabled: null,
      isCancellationMessageEnabled: false
    };
  }

  componentWillMount() {
    if (
      !this.props.location ||
      !this.props.location.state ||
      !this.props.location.state.flightsFilter ||
      !this.props.location.state.quotationJourney ||
      !this.props.location.state.passengerInfo ||
      !this.props.location.state.checkoutInfo ||
      !this.props.location.state.analyticsLogin ||
      !this.props.location.state.bookingResponse
    ) {
      this.setState({
        isRedirect: true,
        pathname: '/'
      });
    } else {
      FeatureService.isFeatureEnabled(Features.AMADEUS_WITH_MASTER_PRICER)
        .then(isMasterPricerEnabled => {
          this.setState({
            booking: this.assembleBookingResponse(
              this.props.location.state.bookingResponse,
              isMasterPricerEnabled
            )
          });
        })
        .catch(() => {
          this.setState({
            booking: this.assembleBookingResponse(this.props.location.state.bookingResponse, false)
          });
        });
      FeatureService.isFeatureEnabled(Features.CALLCENTER_MODE)
        .then(isEnabled => {
          this.setState({
            isCallcenterEnabled: isEnabled
          });
        })
        .catch(() => {
          this.setState({
            isCallcenterEnabled: false
          });
        });
      FeatureService.isFeatureEnabled(Features.FLIGHT_RESUME_CANCELLATION_MESSAGE)
        .then(isEnabled => {
          this.setState({
            isCancellationMessageEnabled: isEnabled
          });
        })
        .catch(() => {
          this.setState({
            isCancellationMessageEnabled: false
          });
        });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.state.isRedirect === false) {
      this.trackingConfirmation();
    }
  }

  componentDidUpdate() {
    this.updateDataCallcenter();
  }

  trackingConfirmation() {
    const dataSelect = this.props.location.state.analyticsDataSelect;
    const dataJourney = this.props.location.state.analyticsDataJourney;
    const dataPassenger = this.props.location.state.analyticsDataPassengers;
    const quotationJourney = this.props.location.state.quotationJourney;
    const checkoutInfo = this.props.location.state.checkoutInfo;
    const analyticsLogin = this.props.location.state.analyticsLogin;
    const pnrNumber = this.props.location.state.bookingResponse.pnrNumber;

    if (
      dataSelect &&
      dataJourney &&
      dataJourney.dataOrigin &&
      dataPassenger &&
      quotationJourney.values &&
      checkoutInfo
    ) {
      const dataCheckout = {
        totalPoints: quotationJourney.values.totalPoints,
        totalTaxes: quotationJourney.values.totalTaxesServices,
        creditCardFlag: checkoutInfo.cardType,
        pnr: pnrNumber
      };
      Analytics.trackingConfirmation(
        dataSelect,
        dataJourney.dataOrigin,
        dataJourney.dataReturn,
        dataPassenger,
        dataCheckout,
        analyticsLogin
      );
    }
  }

  assembleBookingResponse(bookingResponse, isAmadeusWithMasterPrice) {
    if (isAmadeusWithMasterPrice) {
      return this.assembleBookingMasterPriceResponse(bookingResponse);
    }

    const bookingItem = bookingResponse.cart.items[0];
    const paymentItem = bookingResponse.payment.items[0];
    const totalPoints = bookingResponse.cart.total.filter(
      totalItem => totalItem.currency === POINTS
    )[0].value;
    const totalTax = bookingResponse.cart.total.filter(totalItem => totalItem.currency === TAX)[0]
      .value;
    const totalMoney = bookingResponse.total.filter(totalItem => totalItem.currency === MONEY)[0].value;
    const installment = bookingResponse.installment;

    return {
      pnrNumber: bookingResponse.pnrNumber,
      balance: bookingResponse.balance,
      principalContact: bookingResponse.principalContact.firstName,
      originAirportCode: bookingItem.origin,
      destinationAirportCode: bookingItem.destination,
      originAirportName: bookingItem.originAirportName,
      destinationAirportName: bookingItem.finalDestinationName,
      departureFlight: bookingItem.departureFlight,
      returnFlight: bookingItem.returnFlight,
      passengers: bookingResponse.passengers,
      payment: {
        tax: parseFloat(totalMoney ? parseFloat(totalMoney) + parseFloat(totalTax) :  totalTax),
        vendorCode: paymentItem.vendorCode,
        binNumber: paymentItem.binNumber
      },
      totalPoints: totalPoints,
      totalValue: totalMoney ? totalMoney + totalTax :  totalTax,
      installment: installment
    };
  }

  assembleBookingMasterPriceResponse(bookingResponse) {
    const bookingItem = {
      origin: bookingResponse.originAirportCode,
      destination: bookingResponse.destinationAirportCode,
      originAirportName: bookingResponse.originAirportName,
      finalDestinationName: bookingResponse.destinationAirportName,
      departureFlight: bookingResponse.departureFlight,
      returnFlight: bookingResponse.returnFlight
    };
    const paymentItem = bookingResponse.payment;
    const totalPoints = bookingResponse.total.filter(totalItem => totalItem.currency === POINTS)[0]
      .value;
    const totalTax = bookingResponse.total.filter(totalItem => totalItem.currency === TAX)[0].value;
    const totalMoney = bookingResponse.total.filter(totalItem => totalItem.currency === MONEY)[0].value;
    const installment = bookingResponse.installment;

    bookingItem.departureFlight.prices.forEach(price => {
      price.category = bookingItem.departureFlight.category;
      price.value = parseInt(price.value, 10);
    });

    if (bookingItem.returnFlight) {
      bookingItem.returnFlight.prices.forEach(price => {
        price.category = bookingItem.returnFlight.category;
        price.value = parseInt(price.value, 10);
      });
    }

    return {
      pnrNumber: bookingResponse.pnrNumber,
      balance: bookingResponse.balance,
      principalContact: bookingResponse.principalContactFirstName,
      originAirportCode: bookingItem.origin,
      destinationAirportCode: bookingItem.destination,
      originAirportName: bookingItem.originAirportName,
      destinationAirportName: bookingItem.finalDestinationName,
      departureFlight: bookingItem.departureFlight,
      returnFlight: bookingItem.returnFlight,
      passengers: bookingResponse.passengers,
      payment: {
        tax: parseFloat(totalMoney ? parseFloat(totalMoney) + parseFloat(totalTax) :  totalTax),
        vendorCode: paymentItem.vendorCode,
        binNumber: paymentItem.binNumber
      },
      totalPoints: parseInt(totalPoints, 10),
      totalValue: parseFloat(totalMoney ? parseFloat(totalMoney) + parseFloat(totalTax) :  totalTax),
      installment: installment
    };
  }

  cookieCallbackUpdate = () => {
    EventEmitter.emitEvent(Listener.UPDATE_HEADER);
  };

  updateDataCallcenter() {
    if(this.state.booking && this.state.booking.balance && this.callCenterMode()){
      const dataCallcenterStorage = localStorage.getItem(LocalStorage.CUSTOMER_DATA_CALLCENTER);
      const actualData = dataCallcenterStorage ? JSON.parse(dataCallcenterStorage) : null;

      if (actualData) {
        var dataNew = {
          pointsBalance: String(this.state.booking.balance)
        };
        dataNew = { ...actualData, ...dataNew };
        localStorage.setItem(LocalStorage.CUSTOMER_DATA_CALLCENTER, JSON.stringify(dataNew));
      }

      const adLoginCallcenterStorage = localStorage.getItem(LocalStorage.AD_LOGIN_CALLCENTER);
      const adLoginCallcenter = adLoginCallcenterStorage ? JSON.parse(adLoginCallcenterStorage) : null;

      if(adLoginCallcenter)
       EventEmitter.emitEvent(Listener.REFRESH_TOKEN_CALLCENTER, adLoginCallcenter.adLogin, adLoginCallcenter.name);  
      EventEmitter.emitEvent(Listener.UPDATE_HEADER);
    }
  }

  renderCookie() {
    if (
      this.state.booking &&
      this.state.booking.balance &&
      this.state.isCallcenterEnabled !== null &&
      !this.callCenterMode()
    ) {
      const updateCookieData = {
        pointsBalance: String(this.state.booking.balance)
      };
      return (
        <LoginCookie
          callbackUpdate={this.cookieCallbackUpdate}
          updateData={updateCookieData}
          callcenterMode={this.callCenterMode()}
        />
      );
    }
  }

  callCenterMode() {
    return this.state.isCallcenterEnabled && isFromCallcenter();
  }

  redirectToHome = () => {
    this.setState({
      isRedirect: true,
      pathname: '/'
    });
  };

  render() {
    if (this.state.isRedirect || this.state.booking) {
      return (
        <div id="pageResume">
          <section className="container-fluid section__outer">
            {(() => {
              if (this.state.isRedirect) {
                return (
                  <Redirect
                    push
                    to={{
                      pathname: this.state.pathname,
                      state: this.state,
                      search: this.props.location ? this.props.location.search : null
                    }}
                  />
                );
              } else {
                return (
                  <div>
                    {this.renderCookie()}
                    <OverviewBreadcrumb
                      id="componentOverviewBreadcrumb"
                      steps={[
                        'components.steps.search',
                        'components.steps.flightSelection',
                        'components.steps.passengers',
                        'components.steps.checkout',
                        'components.steps.confirmation'
                      ]}
                      actual="components.steps.confirmation"
                    />
                    <div className="resumePageBody">
                      <FlightInfoResume
                        principalContact={this.state.booking.principalContact}
                        pnrNumber={this.state.booking.pnrNumber}
                        originAirportCode={this.state.booking.originAirportCode}
                        originAirportName={this.state.booking.originAirportName}
                        destinationAirportCode={this.state.booking.destinationAirportCode}
                        destinationAirportName={this.state.booking.destinationAirportName}
                        isCancellationMessageEnabled={this.state.isCancellationMessageEnabled}
                        isCallcenterEnabled={this.callCenterMode()}
                      />
                      <FlightResume
                        id="componentFlightResume"
                        departureFlight={this.state.booking.departureFlight}
                        returnFlight={this.state.booking.returnFlight}
                        passengers={this.state.booking.passengers}
                        isCallcenterEnabled={this.callCenterMode()}
                      />
                      <DynamicPanel
                        id="componentDynamicPanelPaymentData"
                        title={I18n.translate('resume.paymentData')}>
                        <PaymentData
                          id="componentPaymentData"
                          passengers={this.state.booking.passengers}
                          departureFlight={this.state.booking.departureFlight}
                          returnFlight={this.state.booking.returnFlight}
                          payment={this.state.booking.payment}
                          totalPoints={this.state.booking.totalPoints}
                          totalValue={this.state.booking.totalValue}
                          installment={this.state.booking.installment}
                        />
                      </DynamicPanel>
                      <DynamicPanel
                        id="componentDynamicPanelTravelTips"
                        title={I18n.translate('resume.travelTips')}>
                        <TravelTips id="componentTravelTips" />
                      </DynamicPanel>
                      <Row className="ResumePage__returnToHomeContainer">
                        <Col xs={12}>
                          <Button id="returnToHomeButton" onClick={this.redirectToHome}>
                            {I18n.translate('resume.returnToHome')}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                );
              }
            })()}
          </section>
        </div>
      );
    } else {
      return <div />;
    }
  }
}

export default ResumePage;



// WEBPACK FOOTER //
// ./src/page/resume/ResumePage.jsx